import { render, staticRenderFns } from "./productHercules.vue?vue&type=template&id=9632f634&scoped=true"
import script from "./productHercules.vue?vue&type=script&lang=js"
export * from "./productHercules.vue?vue&type=script&lang=js"
import style0 from "./productHercules.vue?vue&type=style&index=0&id=9632f634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9632f634",
  null
  
)

export default component.exports